module.exports = __webpack_public_path__ + "img/26.a74f9886.jpg";